const autoWeekend = `

The weekend event **starts every Friday at 4:00 PM** and **ends Sunday at 00:00 AM**.

All events are **random** and **not in order**. Once an event has been activated, it will not start again until all other events have been triggered.

#### Weekend Event Buffs:
- **Buff I**: Max HP/MP+4000, Accuracy/M.Accuracy+35, Atk.Speed./Cast Speed.+57, Critical Rate +14, Critical Power +20
- **Buff II**: Strength/Vitality/Agility/Dexterity/Int/Wisdom +50, Atk.Speed./Cast Speed.+38
- **Buff III**: Strength/Vitality/Agility/Dexterity/Int/Wisdom +30
- **Buff IV**: P.Atk/M.Atk +20%, Atk.Speed./Cast Speed.+30%, Max HP +20%

### Possible Events:
1. **Drop Event**: DROP Event +50%
2. **EXP Event**: EXP Event +50%
3. **Drop and EXP Event**: DROP and EXP +50%
4. **Creatures Event**:
   - Worldbuff Creature hunting
   - Animal Cracker 200%
   - Creature Taming +5
5. **Buff Event**: Randomized buff selection:
   - **Buff 1**: Weekend Event Buff I & IV
   - **Buff 2**: Weekend Event Buff II & IV
   - **Buff 3**: Weekend Event Buff III & IV
   - **Buff 4**: Weekend Event Buff I, II & IV
6. **Special Event**:
   - **Event 1**: Weekend Event Buff I, II, IV + Animal Cracker 200% + Exp +50% + Drop +50%
   - **Event 2 (Rivet)**: This means that this event will not start and the system activates another random event (1-5), making it a rare occurrence.

---

🔹 **More events continued...**`;

export default autoWeekend;
